module.exports = __webpack_public_path__ + "img/sky-porch-balcony.9911a3d8.jpg";